import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { merge } from 'lodash';
import classnames from 'classnames';

import api from 'core/utils/api';
import AppFields from './AppFields';
import StateFields from './StateFields';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

class TestForm extends Component {
  constructor(props) {
    super(props);
    const { initialValues } = this.props;

    this.state = {
      currentStep: 1,
      test: Object.assign(initialValues),
      schema: {},
      loading: false,
    };

    this.handleNext = this.handleNext.bind(this);
  }

  saveTest(test, complete = false) {
    this.props.onSubmit(test, complete);
  }

  fetchFormData(values) {
    const { state_id } = values;
    api.put(`/forms/${state_id}`, values)
      .then((res) => {
        const { schema, data: form_data, ui: uiSchema } = res.data.form;
        this.setState({
          schema,
          test: merge(this.state.test, { form_data }),
          uiSchema
        });
      });
  }

  saveTestProgress(test) {
    const { id } = test;
    if (!id) { return; } // only update when editing a test
    return api.patch(`/tests/${id}`, { test });
  }

  handleNext(values, complete = false) {
    const { test, currentStep } = this.state;
    const nextStep = currentStep + 1;
    this.setState({ test: Object.assign(test, values) }, () => {
      if (nextStep !== 3) {
        this.setState({ currentStep: nextStep });
      }

      if (nextStep === 2) {
        this.saveTestProgress(test);
        this.fetchFormData(values);
      }

      if (nextStep === 3) {
        this.saveTest(test, complete);
      }
    });
  }

  renderAppFields = (currentStep, test) => {
    if (currentStep !== 1) {
      return null;
    }

    return (
      <AppFields
        initialValues={test}
        currentStep={currentStep}
        onSubmit={values => this.handleNext(values)}
      />
    );
  }

  renderStateFields = (currentStep, test) => {
    if (currentStep !== 2) {
      return null;
    }

    return (
      <StateFields
        isEditing={test.id ? true : false}
        formData={test.form_data}
        onSubmit={(values, complete) => this.handleNext(values, complete)}
        schema={this.state.schema}
        uiSchema={this.state.uiSchema}
      />
    );
  }

  renderSteps = () => {
    const { currentStep } = this.state;

    const step1Class = classnames({
      circle: true,
      active: (currentStep === 1),
    });

    const step2Class = classnames({
      circle: true,
      active: (currentStep === 2),
    });

    return (
      <ul className="TestForm__steps">
        <li className="TestForm__steps-item">
          <span className={step1Class}>1</span>
        </li>
        <li className="TestForm__steps-item">
          <span className={step2Class}>2</span>
        </li>
      </ul>
    );
  };

  render() {
    const { currentStep, test } = this.state;

    return (
      <div>
        {this.renderSteps()}

        <Card className="pageCard">
          <CardBody className="padded">
            {this.renderAppFields(currentStep, test)}
            {this.renderStateFields(currentStep, test)}
          </CardBody>
        </Card>
      </div>
    )
  }
}

TestForm.propTypes = propTypes;

export default connect()(TestForm);



// WEBPACK FOOTER //
// ./src/features/test/TestForm/TestForm.js